// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { FaRegCalendarAlt } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import { BASE_URL, USER_URL } from '../../constant/api';

// function AdminCustomers() {
//   const [products, setProducts] = useState([]);
//   // const token = localStorage.getItem('token');

//   // Fetch products on component mount
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await USER_URL.get(`/accounts/admin/all-customers/`, {
//           // headers: { Authorization: `Token ${token}` },
//         });
//         if (response.data?.data) {
//           setProducts(response.data.data);
//         }
//       } catch (error) {
//         console.error('Error fetching products:', error.message || error);
//       }
//     };
//     fetchProducts();
//   }, []);
//   console.log(products);

//   return (
//     <div className="container mx-auto">
//       {/* Table Section */}
//       <div className="overflow-x-auto mt-4">
//         <table className="w-full text-left">
//           <thead>
//             <tr>
//               <th className="text-green-500 text-sm font-bold">Customer Name</th>
//               <th className="p-2 text-green-500 text-sm font-bold">Customer ID</th>
//               <th className="p-2 text-green-500 text-sm font-bold">Location</th>
//               <th className="p-2 text-green-500 text-sm font-bold">Join Date</th>
//               <th className="p-2 text-green-500 text-sm font-bold">Status</th>
//               <th className="p-2 text-green-500 text-sm font-bold">Sub Admin</th>
//               <th className="p-2"></th>
//             </tr>
//           </thead>
//           <tbody>
//             {products.map((product) => (
//               <tr key={product.id}>
//                 <td>
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
//                     {product.username || 'Customer Name'}
//                   </div>
//                 </td>
//                 <td className="p-2">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {product.id || 'ID'}
//                   </div>
//                 </td>
//                 <td className="p-2">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {product.location || 'Location'}
//                   </div>
//                 </td>
//                 <td className="p-2">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
//                     {product.date_joined?.slice(0, 10) || '10/11/2024'}
//                     <FaRegCalendarAlt className="text-gray-400 text-base" />
//                   </div>
//                 </td>
//                 <td className="p-2">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {product.status || 'Inactive'}
//                   </div>
//                 </td>
//                 <td className="p-2">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {product.subAdmin || 'Sub Admin'}
//                   </div>
//                 </td>
//                 <td className="p-2">
//                   <Link
//                     to={`/admin/customers/view/${product.id}`}
//                     className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100"
//                   >
//                     VIEW
//                   </Link>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default AdminCustomers;
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ScaleLoader } from 'react-spinners';  // Import ScaleLoader
import { BASE_URL, USER_URL } from '../../constant/api';

function AdminCustomers() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);  // Loading state

  // Fetch products on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);  // Start loading
        const response = await USER_URL.get(`/accounts/admin/customers/`);
        console.log(response);
        
        if (response.data?.data) {
          setProducts(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching products:', error.message || error);
      } finally {
        setLoading(false);  // Stop loading
      }
    };
    fetchProducts();
  }, []);

  return (
    <div className="container mx-auto">
      {/* Loading Spinner */}
      {loading ? (
        <div className="flex justify-center items-center h-96">
          <ScaleLoader color="#FFAE00" size={60} />  {/* Spinner */}
        </div>
      ) : (
        <div className="overflow-x-auto mt-4">
          <table className="w-full text-left">
            <thead>
              <tr>
                <th className="text-green-500 text-sm font-bold">Customer Name</th>
                <th className="p-2 text-green-500 text-sm font-bold">Customer ID</th>
                <th className="p-2 text-green-500 text-sm font-bold">Location</th>
                <th className="p-2 text-green-500 text-sm font-bold">Join Date</th>
                <th className="p-2 text-green-500 text-sm font-bold">Status</th>
                <th className="p-2 text-green-500 text-sm font-bold">Sub Admin</th>
                <th className="p-2"></th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.id}>
                  <td>
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                      {product.username || 'Customer Name'}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {product.id || 'ID'}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {product.location || 'Location'}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                      {product.date_joined?.slice(0, 10) || '10/11/2024'}
                      <FaRegCalendarAlt className="text-gray-400 text-base" />
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {product.status || 'Inactive'}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                      {product.subAdmin || 'SubAdmin'}
                    </div>
                  </td>
                  <td className="p-2">
                    <Link
                      to={`/admin/customers/view/${product.id}`}
                      className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100"
                    >
                      VIEW
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminCustomers;

